var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24Home(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_24_home",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_box",
    "data-name": "Bounding box",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_color",
    "data-name": "Icon color",
    d: "M17,18H12a1,1,0,0,1-1-1V11.25a.25.25,0,0,0-.25-.25H7.25a.25.25,0,0,0-.25.25V17a1,1,0,0,1-1,1H1a1,1,0,0,1-1-1V9.24A2.981,2.981,0,0,1,.88,7.12L7.71.29A.993.993,0,0,1,8.41,0H9.59a.993.993,0,0,1,.7.29l6.83,6.83A2.981,2.981,0,0,1,18,9.24V17A1,1,0,0,1,17,18ZM6,9h6a1,1,0,0,1,1,1v6h3V9.24a.994.994,0,0,0-.29-.7L9.17,2H8.83L2.29,8.54a.994.994,0,0,0-.29.7V16H5V10A1,1,0,0,1,6,9Z",
    transform: "translate(3 3)",
    fill: "#02466a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24Home);
export default __webpack_public_path__ + "static/media/icon_24_home.4cef47a11d95264dda33c1e2ac18a1a3.svg";
export { ForwardRef as ReactComponent };